<template>
  <h6>Betreutes Wohnen</h6>
  <div class="table-responsive overflow-auto">
    <table id="dataTable1" class="table table-striped">
      <thead>
      <tr>
        <th>Status</th>
        <th>Maßnahmenart</th>
        <th>Standort</th>
        <th>Versicherungsnr</th>
        <th>Start</th>
        <th>Ende</th>
        <th>Stand</th>
        <th>Stand %</th>
        <th>UN fehlt</th>
        <th>Fachkraft 1</th>
        <th>Betreuer 2</th>
        <th>Not Betreuer</th>
        <th>Letzter Termin</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="coaching in assistedLivingCoachingList" :key="coaching.id">
        <td>{{ coaching?.statusTranslation }}</td>
        <td>{{ coaching?.operationTypeTranslation }}</td>
        <td>{{ coaching.unemployed?.location?.name }}</td>
        <td>{{ coaching?.unemployed?.insuranceNumber }}</td>
        <td>{{ coaching?.startDate }}</td>
        <td>{{ coaching?.endDate }}</td>
        <td>{{ coaching?.unitsDone }}</td>
        <td>{{ coaching?.unitsDonePercent }} %</td>
        <td style="text-align: center">{{ coaching?.notSignedMeetings }}</td>
        <td>{{ coaching?.specialist?.firstName }} {{ coaching?.specialist?.lastName }}</td>
        <td>{{ coaching?.supervisor?.firstName }} {{ coaching?.supervisor?.lastName }}</td>
        <td>{{ coaching?.emergencySupervisor?.firstName }} {{ coaching?.emergencySupervisor?.lastName }}</td>
        <td>{{ coaching?.lastUnit }}</td>
        <td>
          <router-link
              :to="{
                  name: 'analyticsUnemployedDetailsOverviewCoachingDetails',
                  params: {
                    coachingType: 'assisted-living-coaching',
                    id: coaching.id
                  }
                }"
              class="btn btn-primary">
            Analytik
          </router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  assistedLivingCoachingList: {
    require: true,
  },
});
</script>
<style scoped>

</style>